import { graphql } from '@guuru/graphql-common/gql';
import communityExpertFragment from '../../../../../graphql/fragments/CommunityExpertFragment';

export default graphql(
  `
    query GetPersistedBestExperts($partnerId: ID!, $first: Int) {
      community(id: $partnerId) {
        id
        experts(first: $first) {
          edges {
            node {
              ...CommunityExpertFragment
            }
          }
        }
      }
    }
  `,
  [communityExpertFragment],
);
